import React from "react";
import { Box, Count, RadioButton, RadioButtonGroup } from "@bca/ui-library";

import prepareFiltersForApiCall from "./prepareFiltersForApiCall";
import { AppliedCheckboxResult } from "../Hooks/useAppliedCheckBoxes";
import { MappedFacetCounts } from "./filters.type";

interface SingleSelectFacetProps {
  categoryKey: string;
  filteredSubfilters: MappedFacetCounts[];
  parentFilterKey: any;
  updateAdditionalFilters: (additionalFilters: { bq: string }) => void;
  additionalFilters: { bq: string };
  label: string;
}

const SingleSelectFacet: React.FunctionComponent<
  SingleSelectFacetProps & AppliedCheckboxResult
> = ({
  categoryKey,
  filteredSubfilters,
  updateAdditionalFilters,
  additionalFilters,
  appliedCheckboxes,
  setAppliedCheckboxesSingleSelect,
  label,
}) => {
  const singleSelectFilter = appliedCheckboxes.find(
    (el) => el.categoryKey === categoryKey
  );

  return (
    <RadioButtonGroup
      value={singleSelectFilter.filterKey}
      name={label}
      onChange={() => {
        /* we are not using this but it is a required prop */
      }}
    >
      {filteredSubfilters?.map(({ filterKey, filterValues }) => {
        const onChange = () => {
          const updatedAppliedCheckboxes = setAppliedCheckboxesSingleSelect(
            filterKey,
            categoryKey
          );
          const apiCallFilters = prepareFiltersForApiCall(
            "bq",
            updatedAppliedCheckboxes,
            additionalFilters
          );
          updateAdditionalFilters({
            bq: apiCallFilters.searchParams.get("bq") || "",
          });
        };
        const hasResults = filterValues[0].count !== 0;
        const variant = hasResults ? "active" : "default";
        const opacity = hasResults ? 1 : 0.5;
        const isSelected = appliedCheckboxes.some(
          (el) => el.filterKey === filterKey && el.categoryKey === categoryKey
        );
        return (
          <Box
            key={filterKey}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            color="footer-blue"
          >
            <RadioButton
              value={filterKey}
              label={filterValues[0].name}
              isSelected={isSelected}
              onChange={onChange}
              disabled={!hasResults}
            />
            <Count
              number={filterValues[0].count}
              variant={variant}
              css={`
                & span {
                  font-size: 14px;
                }
                opacity: ${opacity};
              `}
            />
          </Box>
        );
      })}
    </RadioButtonGroup>
  );
};

export default SingleSelectFacet;
